import React from 'react';
import { RouteObject } from 'react-router-dom';
import SivaAdminIndexPage from './pages/SivaAdminIndexPage';
import SivaAdminBudgetPage from './budget/pages/SivaAdminBudgetPage';
import SivaAdminBudgetYearPage from './budget/pages/SivaAdminBudgetYearPage';
import NotFoundPage from 'src/components/NotFoundPage/NotFoundPage';
import SivaAdminGoalsPage from './goals/pages/SivaAdminGoalsPage';
import SivaAdminGoalsYearPage from './goals/pages/SivaAdminGoalsYearPage';
import SivaAdminGoalsDetailsPage from './goals/pages/SivaAdminGoalsDetailsPage';
import SivaAdminGoalsDetailsConfirmation from './goals/pages/SivaAdminGoalsDetailsConfirmation';
import SivaFunds from './funds/pages/SivaFunds';
import Overview from './funds/pages/Overview';
import Details from './funds/pages/Details';

const routes: RouteObject[] = [
  {
    path: '',
    index: true,
    element: <SivaAdminIndexPage />,
  },
  {
    path: `budget`,
    handle: { crumbs: ['budget'] },
    element: <SivaAdminBudgetPage />,
  },
  {
    path: `budget/:year`,
    handle: { crumbs: ['budget', ':year'] },
    element: <SivaAdminBudgetYearPage />,
  },
  {
    path: `goals`,
    handle: { crumbs: ['targetNumber'] },
    element: <SivaAdminGoalsPage />,
  },
  {
    path: `goals/:year`,
    handle: { crumbs: ['targetNumber', ':year'] },
    element: <SivaAdminGoalsYearPage />,
  },
  {
    path: `goals/:year/details/:clusterId`,
    handle: { crumbs: ['targetNumber', ':year', '', ''] },
    element: <SivaAdminGoalsDetailsPage />,
  },
  {
    path: `goals/:year/details/:clusterId/confirmation`,
    handle: { crumbs: ['targetNumber', ':year', '', '', 'sivaAdmin.confirmation'] },
    element: <SivaAdminGoalsDetailsConfirmation />,
  },
  {
    path: `funds`,
    handle: { crumbs: ['sivaAdmin.funds'] },
    children: [
      { path: '', index: true, element: <SivaFunds /> },
      {
        path: ':year',
        handle: { crumbs: [':year'] },
        children: [
          { path: '', element: <Overview />, index: true },
          { path: ':clusterId', element: <Details /> },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
